import { ResolvedItinerary } from 'clientState/resolvers/itinerary';
import React, { useState, createContext, useContext, useEffect } from 'react';
import { usePerformedSearchRequest } from '../SearchRequestProvider';

export type SelectedDepartureItinerary =
  | (ResolvedItinerary & {
      price: {
        amount: number;
        currency: string;
      };
    })
  | null;
type SelectedUnbundleDepartureContextType = [
  SelectedDepartureItinerary,
  (id: SelectedDepartureItinerary) => void
];
const SelectedUnbundleDepartureContext =
  createContext<SelectedUnbundleDepartureContextType>([null, () => {}]);

export const SelectedUnbundleDepartureProvider = ({ children }) => {
  const selectedUnbundleDepartureId =
    useState<SelectedDepartureItinerary>(null);
  const [_, setUnbundleDeparture] = selectedUnbundleDepartureId;
  const searchRequest = usePerformedSearchRequest();

  useEffect(() => {
    if (searchRequest && !window.location.hash.includes('step=')) {
      setUnbundleDeparture(null);
    }
  }, [searchRequest, setUnbundleDeparture]);

  return (
    <SelectedUnbundleDepartureContext.Provider
      value={selectedUnbundleDepartureId}
    >
      {children}
    </SelectedUnbundleDepartureContext.Provider>
  );
};

export const useSelectedUnbundleDeparture = () =>
  useContext(SelectedUnbundleDepartureContext);

export const useSelectedUnbundleDepartureId = (): string | null => {
  const [selectedUnbundleDeparture] = useSelectedUnbundleDeparture();
  return selectedUnbundleDeparture?.id || null;
};
